export default __webpack_public_path__ + "f1754d862c15e89f514d2833bd52dbb9.svg";